<template>
  <b-card no-body header="流年變動歲數" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">

  <b-list-group flush>
    <b-list-group-item v-for="(item , index) in listdata" v-bind:key="index"  >
      <h6 class="text-primary">{{ item.year }}</h6>
      <p>{{ item.result }}</p>
    </b-list-group-item>
  </b-list-group>
  </b-card>
</template>
<script>

export default {
  name: 'PersonAllYearResultCard',
  props: {
    listdata:Array,
    color:String,
  },
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>
